import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './adsComponent.css';

const AdsComponent = ({ requiredSize }) => {
  const [ads, setAds] = useState([]);
  const [currentAdIndexes, setCurrentAdIndexes] = useState({}); 

  useEffect(() => {
    const fetchAds = async () => {
      try {
        const response = await axios.get('/api/ads/active');
        setAds(response.data);
      } catch (error) {
        console.error('Error fetching ads:', error);
      }
    };

    fetchAds();
  }, []);

  useEffect(() => {
    const intervals = {};

    ads.forEach((ad) => {
      if (ad && ad.image_size) {
        if (!intervals[ad.image_size]) {
          intervals[ad.image_size] = setInterval(() => {
            setCurrentAdIndexes((prevIndexes) => {
              const currentIndex = prevIndexes[ad.image_size] || 0;
              const adsOfSize = ads.filter((a) => a.image_size === ad.image_size);

              return {
                ...prevIndexes,
                [ad.image_size]: (currentIndex + 1) % adsOfSize.length,
              };
            });
          }, 5000); // Rotate every 5 seconds
        }
      }
    });

    return () => {
      Object.values(intervals).forEach(clearInterval);
    };
  }, [ads]);

  const filteredAds = ads.filter((ad) => ad && ad.image_size === requiredSize);

  if (filteredAds.length === 0) {
    return null;
  }

  const currentAdIndex = currentAdIndexes[requiredSize] || 0;
  const currentAd = filteredAds[currentAdIndex];

  if (!currentAd || !currentAd.image_size) {
    return null;
  }

  const [adWidth, adHeight] = currentAd.image_size.split('x');

  return (
    <div className="ad-container" style={{ width: `${adWidth}px`, height: `${adHeight}px` }}>
      <a href={currentAd.link_url} target="_blank" rel="noopener noreferrer">
        <img
          src={`/${currentAd.image_url}`}
          alt="Ad"
          className="ad-image"
          onError={(e) => (e.target.src = 'https://coinstatshub.tech/uploads/default.webp')}
        />
      </a>
    </div>
  );
};

export default AdsComponent;
